import React, { useEffect, useState } from "react";
import "./kpi.css";

function Kpi({ cardData }) {
  const [clinicCardData, setClinicCardData] = useState(null);
  useEffect(() => {
    setClinicCardData(cardData);
  }, [cardData]);
  // console.log("carddata",clinicCardData)

  function parseFormattedCount(formattedCount) {
    if (formattedCount === "" || typeof formattedCount !== "string") {
      return formattedCount;
    }

    const numericalPart = parseFloat(formattedCount);
    const unitPart = formattedCount.slice(-1);

    if (unitPart === "K" || unitPart === "M" || unitPart === "B") {
      switch (unitPart) {
        case "K":
          return numericalPart * 1e3;
        case "M":
          return numericalPart * 1e6;
        case "B":
          return numericalPart * 1e9;
        default:
          // If the unit is unknown, return NaN (Not a Number)
          return NaN;
      }
    } else {
      return numericalPart;
    }
  }

  function formatCount(count) {
    if (count >= 1000) {
      return (count / 1000).toFixed(1) + "k";
    }
    return count;
  }

  return (
    <div className="report mt-4">
      <section className="d-flex justify-content-between" style={{ gap: "3rem" }}>
        <div className="d-flex justify-content-between mt-2" style={{ flexDirection: "column" }}>
          <div className="icon-box" style={{ background: clinicCardData && clinicCardData.background }}>
            {clinicCardData && clinicCardData.icon}
          </div>
          <div className="kpi-card-title mt-2">
            <span>{clinicCardData && clinicCardData.cartTitle}</span>
          </div>
          <div className="">
            <span className="card-count text-nowrap">
              {clinicCardData && clinicCardData.cardType != "Revenue" && parseFormattedCount(clinicCardData.count) > 0
                ? clinicCardData.count
                : clinicCardData && clinicCardData.cardType == "Revenue" && clinicCardData && clinicCardData.count != "undefined undefined"
                  ? clinicCardData.currencySymbol + formatCount(clinicCardData.count)
                  : 0}
            </span>
          </div>
        </div>

        {clinicCardData && clinicCardData.houseCount != undefined && (
          <div>
            {clinicCardData && parseFormattedCount(clinicCardData.houseCount) > 0 ? (
              <div className="card-icons-section">
                <span className="d-flex align-items-center">
                  <i className="ri-home-line primary-color" data-toggle="tooltip" title="House call"></i>
                  &nbsp;
                  {clinicCardData.houseCount}
                </span>
              </div>
            ) : (
              " "
            )}
            {clinicCardData && parseFormattedCount(clinicCardData.callCount) > 0 ? (
              <div className="card-icons-section my-2">
                <span className="d-flex align-items-center">
                  <i className="ri-phone-line primary-color" data-toggle="tooltip" title="Normal call"></i>
                  &nbsp;
                  {clinicCardData.callCount}
                </span>
              </div>
            ) : (
              ""
            )}
            {clinicCardData && parseFormattedCount(clinicCardData.visitCount) > 0 ? (
              <div className="card-icons-section my-2">
                <span className="d-flex align-items-center">
                  <i className="ri-walk-line primary-color" data-toggle="tooltip" title="Walk-in"></i>
                  &nbsp;
                  {clinicCardData.visitCount}
                </span>
              </div>
            ) : (
              ""
            )}
            {clinicCardData && parseFormattedCount(clinicCardData.videoCount) > 0 ? (
              <div className="card-icons-section my-2">
                <span className="d-flex align-items-center">
                  <i className="ri-live-line primary-color" data-toggle="tooltip" title="Video call"></i>
                  &nbsp;
                  {clinicCardData.videoCount}
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        )}
      </section>
    </div>
  );
}

export default Kpi;
